import automaticOptimizationModule from "./automaticOptimizationModule"
import server from "../server"

automaticOptimizationModule.service("automaticOptimizationService", ["$http", ($http) => {
    return {
        save: save,
        findUsers: findUsers,
        findAutomaticOptimizationConfig: findAutomaticOptimizationConfig,
        editAutomaticOptimizationConfig: editAutomaticOptimizationConfig,
        copyAutomaticOptimizationConfig: copyAutomaticOptimizationConfig,
        deleteAutomaticOptimizationConfig: deleteAutomaticOptimizationConfig,
        getAutomaticOptimizationClassifications: getAutomaticOptimizationClassifications
    }

    function save(automaticOptimizationConfig) {
        return $http.post(server.getServiceUrl("automaticOptimization") + "save", automaticOptimizationConfig).then((response) => response.data)
    }

    function findUsers(sourceId) {
        return $http.get(server.getServiceUrl("automaticOptimization") + "find-users", {
            params: {
                sourceId: sourceId
            }
        } ).then((response) => response.data)
    }

    function findAutomaticOptimizationConfig(template, firstResult, maxResults){
        return $http.post(server.getServiceUrl("automaticOptimization") + "presentation-tree", template, {
            params: {
                firstResult: firstResult,
                maxResults: maxResults
            }
        } ).then((response) => response.data)

    }

    function editAutomaticOptimizationConfig(automaticOptimizationConfigId){
        return $http.post(server.getServiceUrl("automaticOptimization") + "edit", automaticOptimizationConfigId ).then((response) => response.data)
    }

    function copyAutomaticOptimizationConfig(automaticOptimizationConfigId){
        return $http.post(server.getServiceUrl("automaticOptimization") + "copy", automaticOptimizationConfigId ).then((response) => response.data)
    }

    function deleteAutomaticOptimizationConfig(automaticOptimizationConfigId){
        return $http.post(server.getServiceUrl("automaticOptimization") + "delete", automaticOptimizationConfigId ).then((response) => response.data)
    }

    function getAutomaticOptimizationClassifications() {
        return $http.get(server.getServiceUrl("automaticOptimization") + "get-automatic-optimization-classifications", {} ).then((response) => response.data)
    }

}])